import { useEffect, useState } from 'react';
import { getApiBaseUrl } from '../../../utils/apiConfig';

export function useOrderDetailsPedidoDetalhe(codigoPedido, enabled, native = false) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const cod = String(codigoPedido ?? '').trim();
    if (!enabled || !cod) {
      setData(null);
      setError(null);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setData(null);

    const token = localStorage.getItem('authToken');
    const base = getApiBaseUrl();

    fetch(`${base}/api/orders/pedido/${encodeURIComponent(cod)}/detalhe-completo${native ? '?nativa=1' : ''}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (cancelled) return;
        if (json?.success && json.data) {
          setData(json.data);
        } else {
          setData(null);
          setError(json?.message || 'Não foi possível carregar os detalhes do pedido.');
        }
      })
      .catch(() => {
        if (!cancelled) {
          setData(null);
          setError('Erro ao carregar detalhes do pedido.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [codigoPedido, enabled, native]);

  return { data, loading, error };
}
